import { Icons } from "assets/icons";
import FilterBar from "components/common/FilterBar";
import NoDataFound from "components/common/NoDataFound";
import Paginations from "components/common/Paginations";
import { StatusBadge } from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import TableShimmer from "components/common/TableShimmer";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getVehicleDetails,
  resetFilters,
  setFilter,
} from "store/slices/customersSlice";
import { ORDER_BY_OPTIONS } from "utils/constants";
import { getActionFlags } from "utils/getActionFlags";
import { formatUTCDate, getMinMaxDate } from "utils/utils";

const LeadVehicleDetails = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    loading2,
    totalPages,
    currentPage,
    totalCount,
    perPage,
    vehicleDetails,
    filters: { customerVehiclesKeyword, dates, orderBy },
  } = useSelector((state) => state.Customers);
  const { noVehicles } = Icons || {};

  useEffect(() => {
    getAllData();
  }, []);
  const getAllData = (page, action) => {
    const { isReset, isResetKeyword } = getActionFlags(action);

    const payload = {
      perPage: 10,
      pageNo: page || 1,
      orderBy: isReset ? -1 : orderBy,
      userId: id ?? "",
      keyword: isResetKeyword ? "" : customerVehiclesKeyword || "",
      dateRange: isReset ? {} : getMinMaxDate(dates),
    };

    dispatch(getVehicleDetails(payload));
  };
  const filtersList = [
    {
      key: "orderBy",
      placeholder: t("Order By"),
      type: "singleSelect",
      options: ORDER_BY_OPTIONS,
    },
  ];
  const handleReset = () => {
    dispatch(resetFilters());
    getAllData(1, { actionType: "RESET" });
  };

  const columns = useMemo(
    () => [
      {
        header: t("Plate Number"),
        key: "licencePlateNumber",
        render: (value) => <div className="ltr_text">{value || "-"}</div>,
      },
      {
        header: t("Created Date"),
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: t("Status"),
        key: "status",
        render: (value) => <StatusBadge status={value} t={t} />,
      },
    ],
    [t],
  );

  return (
    <div className="">
      <FilterBar
        keyword={customerVehiclesKeyword}
        setKeyword={(value) =>
          dispatch(setFilter({ key: "customerVehiclesKeyword", value }))
        }
        keywordPlaceholder={t("Plate Number")}
        filters={filtersList}
        selectedFilters={{ customerVehiclesKeyword, orderBy }}
        onFilterUpdate={(key, value) => dispatch(setFilter({ key, value }))}
        onSearch={getAllData}
        onReset={handleReset}
        isDateRange={true}
        dates={dates}
        setDates={(value) => dispatch(setFilter({ key: "dates", value }))}
        className="lead_vehicle"
      />
      {loading2 && <TableShimmer rows={12} columns={8} />}

      {!loading2 && vehicleDetails?.length === 0 && (
        <NoDataFound title={t("No vehicles found")} icon={noVehicles} />
      )}

      {!loading2 && vehicleDetails?.length > 0 && (
        <>
          <DataTable
            columns={columns}
            data={vehicleDetails}
            emptyMessage={t("No vehicles found")}
            t={t}
          />
          <Paginations
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            onPageChange={getAllData}
            className="mb-0"
          />
        </>
      )}
    </div>
  );
};

export default LeadVehicleDetails;
